import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';
import ProjectLocation from './ProjectLocation/index';

const ProjectLocationContainer = ({ isSkeleton }) => {
  return (
    <Card style={{ marginBottom: '10px', border: 'none' }}>
      <CardTitle
        data-testid="project-locations"
        header={(
          <Typography variant="h3" weight="bold">
            Your Preferred Store
          </Typography>
        )}
      />
      <ProjectLocation isSkeleton={isSkeleton} />
    </Card>
  );
};

ProjectLocationContainer.propTypes = {
  isSkeleton: PropTypes.bool
};
ProjectLocationContainer.defaultProps = {
  isSkeleton: false
};

export { ProjectLocationContainer };
